// extracted by mini-css-extract-plugin
export default {"addNewRequestButton":"manage-requests_addNewRequestButton__dHOnx"};